<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Edit" class="d-icon d-icon--edit" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M1 10V3a1.5 1.5 0 0 1 1.5-1.5H6a.5.5 0 0 1 0 1H2.5A.5.5 0 0 0 2 3v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V6.5a.5.5 0 0 1 1 0V10a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10Zm10.06-8a.56.56 0 0 0-.957-.396l-4.652 4.65-.263 1.059 1.056-.265 4.652-4.652A.56.56 0 0 0 11.06 2Zm1 0c0 .414-.164.81-.457 1.104l-4.75 4.75a.501.501 0 0 1-.232.131l-2 .5a.5.5 0 0 1-.606-.606l.5-2 .021-.065a.5.5 0 0 1 .11-.168l4.75-4.75A1.56 1.56 0 0 1 12.06 2Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconEdit',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
